import {
    fetchAsmlDeviceDetails, fetchAsmlDeviceStatusDetails, setAsmlDeviceDetails, updateAsmlDeviceDetails
} from "../network/AsmlDeviceOverviewNetworkAPI";
import {getTimestampNow} from "../../../util/Util";

export const AsmlDeviceOverviewReducer = (state, action) => {
    switch (action.type) {
        case "RECEIVE_DATA":
            return {...state, ...action.data, loadingOverview: false, timestamp: getTimestampNow()}
        case "LOAD_VIEW":
            fetchAsmlDeviceDetails(action.data.dispatcher)
            return state
        case "LOAD_STATUS":
            fetchAsmlDeviceStatusDetails(action.data.dispatcher, state)
            return state
        case "ADD_DEVICE_DATA":
            setAsmlDeviceDetails(action.data.dispatcher, action.data.stateValues)
            return state
        case "UPDATE_DEVICE_DATA":
            updateAsmlDeviceDetails(action.data.dispatcher, action.data.stateValues)
            return state
        case "SORT_DATA":
            return {...state, sortPref: action.data}
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/components/devicemanagement/asmldevice/reducer/AsmlDeviceOverviewReducer.js